export const API_URL = process.env.REACT_APP_API_URL || 'https://98fzfcf5hk.execute-api.eu-west-3.amazonaws.com/v2';
export const AGENT_SECRET = process.env.REACT_APP_AGENT_SECRET || 'vsk-adm-f7a2e91c4b8d3e56a0f1c2d4b7e9a3f8';
